import { render, staticRenderFns } from "./ReportMenuSection.vue?vue&type=template&id=4dd44b0c&"
import script from "./ReportMenuSection.vue?vue&type=script&lang=js&"
export * from "./ReportMenuSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbrown/projects/okinus/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4dd44b0c')) {
      api.createRecord('4dd44b0c', component.options)
    } else {
      api.reload('4dd44b0c', component.options)
    }
    module.hot.accept("./ReportMenuSection.vue?vue&type=template&id=4dd44b0c&", function () {
      api.rerender('4dd44b0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/fndry-vue/packages/fn-ui/components/report/ReportMenu/ReportMenuSection/ReportMenuSection.vue"
export default component.exports